import { GraphKinds, IRangeOfMotionBehavior, ILineGraphBehavior } from "../../../../documaker/domain/format/objects";
import { IRectangleCoordinatableObject, instanceOfIRectangleCoordinatableObject } from "./IRectangleCoordinatableObject";

export interface IGraphObject extends IRectangleCoordinatableObject {
  kind: GraphKinds;
  behavior: IRangeOfMotionBehavior | ILineGraphBehavior;
}

export function instanceOfIGraphObject(instance: any): instance is IGraphObject {
  return instance
      && (instance.kind !== undefined)
      && (instance.behavior !== undefined)
      && instanceOfIRectangleCoordinatableObject<IGraphObject>(instance, "graph");
}
